import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'coachingReasonPipe',
})
export class CoachingReasonPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    switch (value) {
      case 'RECURRING_EVENTS':
        return 'Recurring Events';

      case 'MISSED_SELF_COACHING_SESSIONS':
        return 'Missed Self Coaching Sessions';

      case 'EVENT_BASED_ESCALATION':
        return 'Event-Based Escalation';

      case 'ESCALATED_EVENTS':
        return 'Escalated Events';

      default:
        return value;
    }
  }
}
